import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
export function StickyTopBar() {
  const [secondsLeft, setSecondsLeft] = useState(() => {
    const saved = sessionStorage.getItem('countdown_end');
    if (saved) {
      const remaining = Math.floor((parseInt(saved) - Date.now()) / 1000);
      return remaining > 0 ? remaining : 0;
    }
    const end = Date.now() + 10 * 60 * 1000;
    sessionStorage.setItem('countdown_end', String(end));
    return 10 * 60;
  });
  useEffect(() => {
    if (secondsLeft <= 0) return;
    const interval = setInterval(() => {
      setSecondsLeft(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [secondsLeft > 0]);
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const timeDisplay = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  return <div className="sticky top-0 z-50 w-full bg-[#1a1a2e] text-white py-3 px-5 shadow-sm" data-id="element-209">
      <div className="max-w-5xl mx-auto flex items-center justify-center text-center text-sm font-medium gap-2" data-id="element-210">
        <ClockIcon className="w-4 h-4 text-white/80 flex-shrink-0" data-id="element-211" />
        <span className="text-white/90" data-id="element-212">La oferta finalizará en</span>
        <span className="tabular-nums tracking-wider text-white font-semibold" data-id="element-213">
          {timeDisplay}
        </span>
      </div>
    </div>;
}